import { render, staticRenderFns } from "./wage-th.vue?vue&type=template&id=1dba9dec&"
import script from "./wage-th.vue?vue&type=script&lang=js&"
export * from "./wage-th.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports